// extracted by mini-css-extract-plugin
export default {"button-with-hover":"QUj2u8Sq","FooterContainer":"ZvxrNlvc"};